import { useFetchBusinessById } from '@expane/data'
import { store } from 'store'

export function useFetchCurrentBusiness() {
  const id = store.me.businessId
  return useFetchBusinessById(id)
}
